import { ReportBuilder } from "@/components/billing/report-builder";
import { ApiError, api } from "@/lib/api";
import { Link, createFileRoute, redirect } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * `/billing/new` — the report generator, on its own page.
 *
 * Reached via the "Generate report" button on `/billing`. Picking a
 * customer + period and generating lands the operator on the new
 * report's detail page.
 */

type CustomerOption = { id: string; name: string };

export const Route = createFileRoute("/_app/billing/new")({
  loader: async () => {
    try {
      const customers = await api.get<{ customers: CustomerOption[] }>(
        "/api/customers?pageSize=200",
      );
      return { customers: customers.customers };
    } catch (err) {
      if (err instanceof ApiError && err.status === 403) {
        throw redirect({ to: "/my" });
      }
      throw err;
    }
  },
  component: GenerateReportPage,
});

function GenerateReportPage() {
  const { t } = useTranslation();
  const { customers } = Route.useLoaderData();

  return (
    <div className="space-y-6">
      <div>
        <Link
          to="/billing"
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          {t("billing.new.back")}
        </Link>
        <h1 className="font-heading text-2xl font-bold mt-2">{t("billing.new.title")}</h1>
        <p className="text-muted-foreground text-sm mt-1">{t("billing.new.subtitle")}</p>
      </div>

      <ReportBuilder customers={customers} />
    </div>
  );
}
